import { Autocomplete, Box, Button, Card, Input, Table, Typography, IconButton, Tooltip } from '@mui/joy';
import Upload from '@mui/icons-material/Upload';
import React, { useState, useEffect } from 'react';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
function TarifFileUploader({ pflichtdateien, dateiendata, setdateiendata, setfile, files }) {
    const [create, setcreate] = useState(false);
    const [selectedtype, setselectedtype] = useState(null);
    const [name, setname] = useState('');
    const [file, setf] = useState(null);
    const [missing, setmissing] = useState([]);

    useEffect(() => {
        setmissing(findMissingByName(pflichtdateien, dateiendata));
    }, [pflichtdateien, dateiendata]);

    function findMissingByName(listOfObjects = [], dataMap = new Map()) {
        const existingTypes = new Set(
            Array.from(dataMap.values()).map(entry => entry.type?.dateiname)
        );
        return listOfObjects.filter(obj => !existingTypes.has(obj["dateiname"]));
    }

    function handleChange(e) {
        const f = e.target.files[0];
        if (f) setf(f);
    }

    function add() {
        if (!name || !selectedtype || !file) return;

        const fd = new Map(files);
        fd.set(file.name, file);
        setfile(fd);

        const dd = new Map(dateiendata);
        console.log(selectedtype);
        dd.set(file.name, { dateiname: name, type: selectedtype, n: name});
        setdateiendata(dd);

        // Reset form
        setname('');
        setselectedtype(null);
        setf(null);
        setcreate(false);
    }
    function remove(n) {
        const dd = new Map(dateiendata);
        const fd = new Map(files);
        dd.delete(n);
        setdateiendata(dd);
        fd.delete(n);
        setfile(fd);
    }

    return (
        <>
            {missing.length > 0 && (
                <Card variant="soft" sx={{ bgcolor: "#ffebee", p: 2, mb: 3 }}>
                    <Typography level="title-md">Fehlende Dateien!</Typography>
                    <Typography>Bitte lade folgende Dateien hoch:</Typography>
                    {missing.map((item, i) => (
                        <Typography key={i}>• {item.dateiname}</Typography>
                    ))}
                </Card>
            )}

            {create && (
                <Card variant="soft" sx={{ mt: 3, p: 2 }}>
                    <Typography level="title-md" gutterBottom>Neue Datei hinzufügen</Typography>

                    <Typography>Dateiname</Typography>
                    <Input value={name} onChange={(e) => setname(e.target.value)} placeholder='Bitte eingeben' sx={{ width: "30%", mb: 2 }} />

                    <Typography>Dateityp</Typography>
                    <Autocomplete
                        onChange={(e, v) => setselectedtype(v)}
                        options={pflichtdateien}
                        getOptionLabel={(item) => item.dateiname}
                        sx={{ width: "30%", mb: 2 }}
                        value={selectedtype}
                    />

                    <Typography>Ausgewählte Datei:{file ? ` ${file.name}` : " Keine"}</Typography>
                    <input
                        type="file"
                        id="file-upload"
                        style={{ display: 'none' }}
                        onChange={handleChange}
                    />
                    <label htmlFor="file-upload">
                        <Tooltip title="Datei auswählen">
                            <IconButton component="span" variant="soft" color="primary">
                                <Upload />
                                <Typography sx={{ ml: 1 }}>Datei auswählen</Typography>
                            </IconButton>
                        </Tooltip>
                    </label>

                    <Box mt={2}>
                        <Button onClick={add} sx={{ width: "25%" }}>
                            Hinzufügen
                        </Button>
                    </Box>
                </Card>
            )}

            <Card variant="soft" sx={{ mt: 5 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography level="title-md">Vorhandene Dateien</Typography>
                    <Button onClick={() => setcreate(true)}>Hinzufügen</Button>
                </Box>
                <Table sx={{ '& thead th:nth-child(1)': { width: '35%' } }}>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Typ</th>
                            <th>Dateiname</th>
                            <th>Bearbeiten</th>
                        </tr>
                    </thead>
                    <tbody>
                        {[...dateiendata.entries()].map(([k, v]) => (
                            <tr key={k}>
                                <td>{v.dateiname}</td>
                                <td>{v.type?.dateiname || "-"}</td>
                                <td>{k}</td>
                                <td><Button variant='soft' color='danger' startDecorator={<DeleteForeverOutlinedIcon />}
                                    onClick={() => {
                                        remove(k);
                                    }}
                                >Löschen</Button></td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Card>
        </>
    );
}

export default TarifFileUploader;
